import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';

export const coordinateSystemsKey = 'coordinateSystems';

export const coordinateSystemsAdapter = createEntityAdapter<ICoordinateSystem>({
  selectId: coordinateSystem => coordinateSystem.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export interface ICoordinateSystemsState extends EntityState<ICoordinateSystem> {
  loading: boolean;
  loaded: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialState: ICoordinateSystemsState = coordinateSystemsAdapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});
